import { GlobalAxios } from "./../axios/axios-config";
import { INewIProcesse, IIProcesse } from "../models/i-processe";
import { ISelectType } from "@4uhub/lib4uhub";

const I_PROCESSE_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/IProcesse/";

export const createIProcesse = (item: INewIProcesse) => {
  return GlobalAxios.post(I_PROCESSE_ROUTE, item);
};

export const getIProcesseById = (id: string) => {
  return GlobalAxios.get<IIProcesse>(I_PROCESSE_ROUTE + id);
};

export const updateIProcesseById = ({
  item,
  id,
}: {
  item: INewIProcesse;
  id: string;
}) => {
  return GlobalAxios.put(I_PROCESSE_ROUTE + id, item);
};

export const iProcesseList = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(I_PROCESSE_ROUTE + "list", {
    params,
  });
};
